import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

import { AlumnoFilter, State } from './types';
import { RequestStatusTypes } from 'consts';
import ActionTypes from './actionTypes';

export const initialState: State = {
  photos: [],
  photosCount: 0,
  estados: [],
  getAlumnsValidationPhotosRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  alumnsValidation: [] as AlumnoFilter[],
  photoValidSelectionStatus: {
    status: RequestStatusTypes.Default,
  },
  photoRejectSelectionStatus: {
    status: RequestStatusTypes.Default,
  },
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    case ActionTypes.SET_PHOTOS:
      return {
        ...state,
        photos: action.payload,
      };
    case ActionTypes.SET_PHOTOS_COUNT:
      return {
        ...state,
        photosCount: action.payload,
      };
    case ActionTypes.SET_GET_ALUMNS_VALIDATIONPHOTOS_REQUEST_STATUS:
      return {
        ...state,
        getAlumnsValidationPhotosRequestStatus: action.payload,
      };

    case ActionTypes.SET_ALUMNS_VALIDATIONPHOTOS:
      return {
        ...state,
        alumnsValidation: action.payload,
      };
    case ActionTypes.REMOVE_PHOTOS_FILTER:
      return {
        ...state,
        alumnsValidation: [],
      };
    case ActionTypes.POST_PHOTO_VALID_SELECTION:
      return {
        ...state,
        photoValidSelectionStatus: action.payload,
      };
    case ActionTypes.SET_POST_PHOTO_REJECT_REQUEST_STATUS:
      return {
        ...state,
        photoRejectSelectionStatus: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
